module.exports = __webpack_public_path__ + "img/DeathProphet.c5ee30bf.png";